/*eslint-disable*/
import React, { useState } from 'react';
import { STYLES } from "config";
import { Card, CardBody, CardTitle } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

// Styles for the component
const useStyles = makeStyles({
    root: {
        flexDirection: "row",
        display: "flex",
        width: "100%",
        height: "100%",
        backgroundColor: "#f8f9fa",
        padding: "0"
    },
    sidebar: {
        width: "250px",
        backgroundColor: "#2c3e50",
        color: "white",
        height: "100vh",
        position: "sticky",
        top: 0,
        overflowY: "auto",
        padding: "20px 0",
        boxShadow: "2px 0 10px rgba(0,0,0,0.1)"
    },
    sidebarItem: {
        padding: "12px 20px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        borderLeft: "4px solid transparent",
        "&:hover": {
            backgroundColor: "#34495e"
        }
    },
    sidebarItemActive: {
        padding: "12px 20px",
        cursor: "pointer",
        backgroundColor: "#3498db",
        borderLeft: "4px solid #fff",
        fontWeight: "600"
    },
    content: {
        flex: 1,
        padding: "20px",
        overflowY: "auto"
    },
    header: {
        width: "100%",
        maxWidth: "1200px",
        marginBottom: "30px",
        textAlign: "center"
    },
    pageTitle: {
        fontSize: "28px",
        fontWeight: "600",
        color: "#2c3e50",
        marginBottom: "8px"
    },
    pageSubtitle: {
        fontSize: "16px",
        color: "#7f8c8d",
        marginBottom: "0"
    },
    Card: {
        width: "100%",
        padding: "20px",
        minWidth: "275px",
        border: "1px solid",
        borderColor: "#e0e0e0",
        borderRadius: "12px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
        marginBottom: "20px",
        backgroundColor: "#ffffff"
    },
    CardHeader: {
        fontSize: "20px",
        fontWeight: "600",
        color: "#2c3e50",
        margin: "0 0 15px 0",
        paddingBottom: "15px",
        position: "relative"
    },
    separator: {
        height: "2px",
        width: "100%",
        backgroundColor: "#e0e0e0",
        position: "absolute",
        bottom: "0",
        left: "0"
    },
    cardBody: {
        margin: "0",
        padding: "0"
    },
    twoColumnLayout: {
        display: "flex",
        gap: "20px",
        width: "100%",
        maxWidth: "1200px",
        "@media (max-width: 900px)": {
            flexDirection: "column"
        }
    },
    column: {
        flex: "1",
        minWidth: "0"
    },
    detailsRow: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 15px",
        backgroundColor: "#f8f9fa",
        borderRadius: "6px",
        marginBottom: "8px"
    },
    detailsRowAlt: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 15px",
        backgroundColor: "#ffffff",
        borderRadius: "6px",
        marginBottom: "8px",
        border: "1px solid #f1f1f1"
    },
    verticalDetails: {
        width: "100%",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderRadius: "6px",
        marginBottom: "10px"
    },
    verticalDetailsAlt: {
        width: "100%",
        padding: "15px",
        backgroundColor: "#ffffff",
        borderRadius: "6px",
        marginBottom: "10px",
        border: "1px solid #f1f1f1"
    },
    InfoDescriptionText: {
        width: "50%",
        color: "#2c3e50",
        fontSize: "14px",
        fontWeight: "600",
        margin: "0"
    },
    InfoText: {
        width: "50%",
        color: "#2c3e50",
        fontSize: "14px",
        fontWeight: "400",
        margin: "0",
        textAlign: "right"
    },
    InfoDescriptionTextVertical: {
        color: "#2c3e50",
        fontSize: "14px",
        fontWeight: "600",
        margin: "0 0 8px 0"
    },
    InfoTextVertical: {
        color: "#2c3e50",
        fontSize: "14px",
        fontWeight: "400",
        margin: "0",
        lineHeight: "1.5"
    },
    sectionTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#2c3e50",
        margin: "20px 0 10px 0",
        paddingBottom: "8px",
        borderBottom: "1px solid #e0e0e0"
    },
    sectionContainer: {
        scrollMarginTop: "20px"
    }
});

function PropertyDetailsDisplay({ listing }) {
    const styles = useStyles();
    const [activeSection, setActiveSection] = useState("record");

    // Helper function to format values for display
    const formatValue = (value) => {
        if (value === null || value === undefined || value === "") return "Not specified";
        if (typeof value === "boolean") return value ? "Yes" : "No";
        return value;
    };

    // Format currency values
    const formatCurrency = (value) => {
        if (!value || value === "Not specified") return "Not specified";
        return `R ${Number(value).toLocaleString()}`;
    };

    // Scroll to section function with offset for fixed banner
    const scrollToSection = (sectionId) => {
        console.log('sectionId', sectionId)
        setActiveSection(sectionId);
        const element = document.getElementById(sectionId);
        const bannerHeight = 80; // Adjust this value to match your banner's height in px
        if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset - bannerHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    // Sidebar navigation items
    const navItems = [
      { id: "record", label: "Record Details" },
        { id: "company", label: "Company Details" },
        { id: "property", label: "Property Details" },
        { id: "address", label: "Address Details" },
        { id: "pricing", label: "Pricing Details" },
        { id: "dimensions", label: "Dimensions" },
        { id: "listing", label: "Listing Details" },
        { id: "features", label: "Property Features" },
        { id: "lease", label: "Lease Details" },
        { id: "mandate", label: "Mandate Details" },
        { id: "seller", label: "Seller / Landlord Details" },
        {id: "rates", label: "Rate & Levies Details"  },
        { id: "marketing", label: "Marketing Details" }
    ];

    return (
        <div className={styles.root}>
            {/* Sidebar Navigation */}
            <div className={styles.sidebar}>
                <div style={{ padding: "0 20px 20px 20px", borderBottom: "1px solid #34495e", marginBottom: "10px" }}>
                    <h3 style={{ margin: "0", fontSize: "18px", fontWeight: "600" }}>Navigation</h3>
                </div>
                {navItems.map((item) => (
                    <div
                        key={item.id}
                        className={activeSection === item.id ? styles.sidebarItemActive : styles.sidebarItem}
                        onClick={() => scrollToSection(item.id)}
                    >
                        {item.label}
                    </div>
                ))}
            </div>

            {/* Main Content */}
            <div className={styles.content}>
                <div className={styles.header}>
                    <h1 className={styles.pageTitle}>Property Details</h1>
                    <p className={styles.pageSubtitle}>Listing #{listing?.id || "N/A"}</p>
                </div>

                {/* Record Details Section */}
                <div id="record" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Record Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Listing Web Ref</p>
                                <p className={styles.InfoText}>{formatValue(listing?.id)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Created Date</p>
                                <p className={styles.InfoText}>{moment(listing?.CreatedAt).format("MMMM Do YYYY, h:mm:ss a")}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Last Updated</p>
                                <p className={styles.InfoText}>{formatValue(listing?.UpdatedAt ? moment(listing?.UpdatedAt).format("MMMM Do YYYY, h:mm:ss a") : null)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Status</p>
                                <p className={styles.InfoText}>{formatValue(listing?.status)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Company Details Section */}
                <div id="company" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Company Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Office</p>
                                <p className={styles.InfoText}>{formatValue(listing?.office)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Assigned Broker</p>
                                <p className={styles.InfoText}>{formatValue(`${listing?.userdetials?.Name} ${listing?.userdetials?.lastName}`)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Property Details Section */}
                <div id="property" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Property Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Property Type</p>
                                <p className={styles.InfoText}>{formatValue(listing?.typeOfProperty)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Usage Type</p>
                                <p className={styles.InfoText}>{formatValue(listing?.industrialCommercial)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Title Type</p>
                                <p className={styles.InfoText}>{formatValue(listing?.typeOfTitle)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>ERF Number</p>
                                <p className={styles.InfoText}>{formatValue(listing?.erf)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Address Details */}
                <div div id="address" className={styles.sectionContainer}>
                <Card className={styles.Card}>
                    <CardTitle className={styles.CardHeader}>
                        Address Details
                        <div className={styles.separator} />
                    </CardTitle>
                    <CardBody className={styles.cardBody}>
                        <div className={styles.verticalDetails}>
                            <p className={styles.InfoDescriptionTextVertical}>Full Address</p>
                            <p className={styles.InfoTextVertical}>{formatValue(listing?.address?.description)}</p>
                        </div>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Street Number</p>
                            <p className={styles.InfoText}>{formatValue(listing?.address?.streetNumber)}</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Street Name</p>
                            <p className={styles.InfoText}>{formatValue(listing?.address?.streetName)}</p>
                        </div>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Unit Number</p>
                            <p className={styles.InfoText}>{formatValue(listing?.address?.unitNumber)}</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Complex Name</p>
                            <p className={styles.InfoText}>{formatValue(listing?.address?.complexName)}</p>
                        </div>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Building Name</p>
                            <p className={styles.InfoText}>{formatValue(listing?.address?.buildingName)}</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Floor Number</p>
                            <p className={styles.InfoText}>{formatValue(listing?.address?.floorNumber)}</p>
                        </div>
                    </CardBody>
                </Card>
                </div>

                {/* Pricing Details Section */}
                <div id="pricing" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Pricing Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>POA</p>
                                <p className={styles.InfoText}>{formatValue(listing?.poa)}</p>
                            </div>

                            {(listing?.type === "sale" || listing?.type === "both") && (
                                <>
                                    <div className={styles.detailsRowAlt}>
                                        <p className={styles.InfoDescriptionText}>Sale Price</p>
                                        <p className={styles.InfoText}>{formatCurrency(listing?.price)}</p>
                                    </div>
                                    <div className={styles.detailsRow}>
                                        <p className={styles.InfoDescriptionText}>Deposit</p>
                                        <p className={styles.InfoText}>{formatCurrency(listing?.deposit)}</p>
                                    </div>
                                    <div className={styles.detailsRowAlt}>
                                        <p className={styles.InfoDescriptionText}>Municipal Value</p>
                                        <p className={styles.InfoText}>{formatCurrency(listing?.municipalValue)}</p>
                                    </div>
                                    <div className={styles.detailsRow}>
                                        <p className={styles.InfoDescriptionText}>Valuation Price</p>
                                        <p className={styles.InfoText}>{formatCurrency(listing?.valuationPrice)}</p>
                                    </div>
                                </>
                            )}

                            {(listing?.type === "To Let" || listing?.type === "both") && (
                                <>
                                    <div className={styles.detailsRowAlt}>
                                        <p className={styles.InfoDescriptionText}>Gross Monthly Rental</p>
                                        <p className={styles.InfoText}>{formatCurrency(listing?.grossmonthlyRental)}</p>
                                    </div>
                                    <div className={styles.detailsRow}>
                                        <p className={styles.InfoDescriptionText}>Rental Deposit</p>
                                        <p className={styles.InfoText}>{formatCurrency(listing?.deposit)}</p>
                                    </div>
                                </>
                            )}

                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Price Per Square Meter</p>
                                <p className={styles.InfoText}>{formatCurrency(listing?.ppsm)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Dimensions */}
                <div id="dimensions" className={styles.sectionContainer}>
                <Card className={styles.Card}>
                    <CardTitle className={styles.CardHeader}>
                        Dimensions
                        <div className={styles.separator} />
                    </CardTitle>
                    <CardBody className={styles.cardBody}>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Gross Lettable Area</p>
                            <p className={styles.InfoText}>{formatValue(listing?.gla)} m²</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Land Size</p>
                            <p className={styles.InfoText}>{formatValue(listing?.landSize)} m²</p>
                        </div>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Floor Size</p>
                            <p className={styles.InfoText}>{formatValue(listing?.floorSize)} m²</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Office Size</p>
                            <p className={styles.InfoText}>{formatValue(listing?.officeSize)} m²</p>
                        </div>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Retail Size</p>
                            <p className={styles.InfoText}>{formatValue(listing?.retailSize)} m²</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Factory Size</p>
                            <p className={styles.InfoText}>{formatValue(listing?.factorySize)} m²</p>
                        </div>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Yard Size</p>
                            <p className={styles.InfoText}>{formatValue(listing?.yardSize)} m²</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Building Height</p>
                            <p className={styles.InfoText}>{formatValue(listing?.buildingHieght)} m</p>
                        </div>
                    </CardBody>
                </Card>
            </div>


                {/* Listing Details Section */}
                <div id="listing" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Listing Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Listing Type</p>
                                <p className={styles.InfoText}>{formatValue(listing?.type)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Availability</p>
                                <p className={styles.InfoText}>{formatValue(listing?.availabilityOption)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>On Market Since</p>
                                <p className={styles.InfoText}>{formatValue(listing?.onMarketSince)}</p>
                            </div>
                            <div className={styles.verticalDetailsAlt}>
                                <p className={styles.InfoDescriptionTextVertical}>Listing Notes</p>
                                <p className={styles.InfoTextVertical}>{formatValue(listing?.additionalNotes ? listing?.additionalNotes : listing?.notes || "")}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Property Features Section */}
                <div id="features" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Property Features
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Power (Amps)</p>
                                <p className={styles.InfoText}>{formatValue(listing?.powerAmps)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>3-phase Power</p>
                                <p className={styles.InfoText}>{formatValue(listing?.threePhasePower)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Truck Access</p>
                                <p className={styles.InfoText}>{formatValue(listing?.truckAccess)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Yard Access</p>
                                <p className={styles.InfoText}>{formatValue(listing?.yardAccess)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Floor Loading</p>
                                <p className={styles.InfoText}>{formatValue(listing?.floorLoading)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Building Grade</p>
                                <p className={styles.InfoText}>{formatValue(listing?.buildingGrade)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Roller Shutter Doors</p>
                                <p className={styles.InfoText}>{formatValue(listing?.rollerShutterDoors)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Height of Roller Shutter</p>
                                <p className={styles.InfoText}>{formatValue(listing?.heightOfRollerShutter)} m</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Height of Eaves</p>
                                <p className={styles.InfoText}>{formatValue(listing?.heightOfEaves)} m</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Stud Height</p>
                                <p className={styles.InfoText}>{formatValue(listing?.studHeight)} m</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Height of Roof</p>
                                <p className={styles.InfoText}>{formatValue(listing?.heightOfRoof)} m</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Height for Racking</p>
                                <p className={styles.InfoText}>{formatValue(listing?.heightForRacking)} m</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Dock Levellers</p>
                                <p className={styles.InfoText}>{formatValue(listing?.dockLevellers)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Height of Dock Levellers</p>
                                <p className={styles.InfoText}>{formatValue(listing?.heightOfDockLevellers)} m</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Security</p>
                                <p className={styles.InfoText}>{formatValue(listing?.security)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Air Conditioning</p>
                                <p className={styles.InfoText}>{formatValue(listing?.airConditioning)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Lease Details Section */}
                <div id="lease" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Lease Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Multi Tenanted</p>
                                <p className={styles.InfoText}>{formatValue(listing?.multiTenanted)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Lease Type</p>
                                <p className={styles.InfoText}>{formatValue(listing?.leaseType)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Lease Period</p>
                                <p className={styles.InfoText}>{formatValue(listing?.leasePeriod)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Available From</p>
                                <p className={styles.InfoText}>{formatValue(listing?.availableFrom)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Sustainability Features Section */}
                {/* <div id="sustainability" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Sustainability Features
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Energy Efficiency</p>
                                <p className={styles.InfoText}>{formatValue(listing?.energyEfficiency)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Water Conservation</p>
                                <p className={styles.InfoText}>{formatValue(listing?.waterConservation)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Waste Management</p>
                                <p className={styles.InfoText}>{formatValue(listing?.wasteManagement)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Green Building Certification</p>
                                <p className={styles.InfoText}>{formatValue(listing?.greenCertification)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div> */}

                {/* Mandate Details Section */}
                <div id="mandate" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Mandate Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Mandate Type</p>
                                <p className={styles.InfoText}>{formatValue(listing?.typeOfMandate)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Mandate Start Date</p>
                                <p className={styles.InfoText}>{formatValue(listing?.mandateStartDate)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Mandate End Date</p>
                                <p className={styles.InfoText}>{formatValue(listing?.mandateEndDate)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Seller/Landlord Details Section */}
                <div id="seller" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Seller / Landlord Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Owner Name</p>
                                <p className={styles.InfoText}>{formatValue(listing?.seller?.ownername)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Company</p>
                                <p className={styles.InfoText}>{formatValue(listing?.seller?.company)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Registration Number</p>
                                <p className={styles.InfoText}>{formatValue(listing?.seller?.registrationNumber)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Email</p>
                                <p className={styles.InfoText}>{formatValue(listing?.seller?.email)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Contact Number</p>
                                <p className={styles.InfoText}>{formatValue(listing?.seller?.cellTel)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {/* Rates & Levies */}
                <div id="rates" className={styles.sectionContainer}>
                <Card className={styles.Card}>
                    <CardTitle className={styles.CardHeader}>
                        Rates & Levies
                        <div className={styles.separator} />
                    </CardTitle>
                    <CardBody className={styles.cardBody}>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Monthly Rates</p>
                            <p className={styles.InfoText}>{formatCurrency(listing?.seller?.monthlyRates)}</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Monthly Levy</p>
                            <p className={styles.InfoText}>{formatCurrency(listing?.seller?.monthlyLevy)}</p>
                        </div>
                        <div className={styles.detailsRow}>
                            <p className={styles.InfoDescriptionText}>Monthly Levy Per m²</p>
                            <p className={styles.InfoText}>{formatCurrency(listing?.seller?.monthlyLevyPerSQM)}</p>
                        </div>
                        <div className={styles.detailsRowAlt}>
                            <p className={styles.InfoDescriptionText}>Special Levy</p>
                            <p className={styles.InfoText}>{formatCurrency(listing?.seller?.specialLevy)}</p>
                        </div>
                    </CardBody>
                </Card>
                </div>

                {/* Viewing Schedule Availability Section */}
                {/* <div id="viewing" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            Viewing Schedule Availability
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Viewing Days</p>
                                <p className={styles.InfoText}>{formatValue(listing?.viewingDays)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Viewing Hours</p>
                                <p className={styles.InfoText}>{formatValue(listing?.viewingHours)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Appointment Required</p>
                                <p className={styles.InfoText}>{formatValue(listing?.appointmentRequired)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Contact for Viewing</p>
                                <p className={styles.InfoText}>{formatValue(listing?.viewingContact)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div> */}

                {/* On Show Details Section
                <div id="onshow" className={styles.sectionContainer}>
                    <Card className={styles.Card}>
                        <CardTitle className={styles.CardHeader}>
                            On Show Details
                            <div className={styles.separator} />
                        </CardTitle>
                        <CardBody className={styles.cardBody}>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Open House Dates</p>
                                <p className={styles.InfoText}>{formatValue(listing?.openHouseDates)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Open House Times</p>
                                <p className={styles.InfoText}>{formatValue(listing?.openHouseTimes)}</p>
                            </div>
                            <div className={styles.detailsRow}>
                                <p className={styles.InfoDescriptionText}>Virtual Tour Available</p>
                                <p className={styles.InfoText}>{formatValue(listing?.virtualTour)}</p>
                            </div>
                            <div className={styles.detailsRowAlt}>
                                <p className={styles.InfoDescriptionText}>Video Walkthrough</p>
                                <p className={styles.InfoText}>{formatValue(listing?.videoWalkthrough)}</p>
                            </div>
                        </CardBody>
                    </Card>
                </div> */}

                {/* Marketing Details */}
                <div id="marketing" className={styles.sectionContainer}>
                <Card className={styles.Card}>
                    <CardTitle className={styles.CardHeader}>
                        Marketing Details
                        <div className={styles.separator} />
                    </CardTitle>
                    <CardBody className={styles.cardBody}>
                        <div className={styles.verticalDetails}>
                            <p className={styles.InfoDescriptionTextVertical}>Marketing Heading</p>
                            <p className={styles.InfoTextVertical}>{formatValue(listing?.marketingHeading)}</p>
                        </div>
                        <div className={styles.verticalDetailsAlt}>
                            <p className={styles.InfoDescriptionTextVertical}>Description</p>
                            <p className={styles.InfoTextVertical}>{formatValue(listing?.description)}</p>
                        </div>
                    </CardBody>
                </Card>
             </div>

            </div>
        </div>
    );
}

export default PropertyDetailsDisplay;